import { createSlice } from "@reduxjs/toolkit";

const initialDayEntrySlice = {
        nestedHeaders: [],
        settings: {
                lockdatesuntil: new Date(1990,1,1)
        },
        dayentries: {
                entries: [], 
                summary: {
                        tanks_count_with_entries: 0,
                        total_no_of_tanks: 0,
                        percent_complete: 0,
                        tanks_without_entries: '',
                        tanks_with_entries: '',
                        totalcount: 0 
                },
                isLoading: false
        },
        tanks: [],
        dropDownSource: { tanks: [] },
        course: {
                isloading: false, open:'', close: ''
        },
        sgdetails: { 
                isloading: false,
                opengravity: null,
                closegravity: null
        },
        tankLiterDetails: {
                isloading: false,
                openvolume: null,
                closevolume: null
        },
        fractionalDetails: { 
                isloading: false,
                openfractional: null,
                closefractional: null,
        },
        movementSummary: {
                delivery: null,
                fromprod: null,
                intertankin: null,
                toprod: null,
                sale: null,
                intertankout: null
        },
        saveStatus: {
                isSaving: false,
                success: null,
                alreadyexists: false,
                error: ''
        },
        dayEntry: {
                details: null, 
                isLoading: false
        },
        cancelStatus: {
                isCancelling: false,
                success: false,
                error: ''
        }
};

export const DayEntrySlice = createSlice({
        name: "dayentry",
        initialState: initialDayEntrySlice,
        reducers: {
                SetTankSoundingSettings: (state, action) => {
                        // console.log(action.payload);
                        state.settings.lockdatesuntil = action.payload.lockdatesuntil;
                },
                SetNestedHeaders: (state, action) => {
                        // console.log(action.payload);
                        state.nestedHeaders = action.payload; 
                },
                StartDayEntries: (state,action) => {
                        state.dayentries = {
                                entries: [], 
                                summary: {
                                        tanks_count_with_entries: 0,
                                        total_no_of_tanks: 0,
                                        percent_complete: 0,
                                        tanks_without_entries: '',
                                        tanks_with_entries: '',
                                        totalcount: 0 
                                },
                                isLoading: true
                        }
                },
                SetDayEntries: (state, action) => {
                        // console.log(action.payload);
                        state.dayentries = {
                                entries: action.payload.entries, 
                                summary: {
                                        percent_complete: action.payload.summary?.percent_complete, 
                                        tanks_without_entries: action.payload.summary?.tanks_without_entries,
                                        tanks_with_entries: action.payload.summary?.tanks_with_entries,
                                        tanks_count_with_entries: action.payload.summary?.tanks_count_with_entries,
                                        total_no_of_tanks: action.payload.summary?.total_no_of_tanks,
                                        totalcount: action.payload.summary?.totalcount
                                },
                                isLoading: false
                        }
                },
                
                SetTanks: (state, action) => {
                        state.tanks = action.payload.tanks;
                },

                SetDropDownSource: (state, action) => {
                        // console.log(action.payload.tanks);
                        state.dropDownSource = {
                                tanks: action.payload.tanks
                        }
                },

                StartGetCourses: (state, action) => {
                        state.course = {
                                isloading: true, open: null, close: null
                        }
                },
                SetCourses: (state, action) => {
                        state.course = {
                                isloading: false,
                                open: action.payload.opencourse,
                                close: action.payload.closecourse
                        }
                },
                StartGetSGDetails: (state, action) => {
                        state.sgdetails = { 
                                isloading: true,
                                opengravity: null,
                                closegravity: null
                        }
                },
                SetSGDetails: (state,action) => {
                        state.sgdetails = { 
                                isloading: false,
                                opengravity: action.payload.opengravity,
                                closegravity: action.payload.closegravity
                        }
                },
                StartGetTankLiterDetails: (state, action) => {
                        state.tankLiterDetails = {
                                isloading: true,
                                openvolume: null,
                                closevolume: null
                        }
                },
                SetTankLiterDetails: (state,action) => {
                        state.tankLiterDetails = {
                                isloading: false,
                                openvolume: action.payload.openvolume,
                                closevolume: action.payload.closevolume
                        }
                }, 
                StartGetFractionalDetails: (state, action) => {
                        state.fractionalDetails = { 
                                isloading: true,
                                openfractional: null,
                                closefractional: null
                        }
                },
                SetFractionalDetails: (state,action) => {
                        state.fractionalDetails = {
                                isloading: false, 
                                openfractional: action.payload.openfractional,
                                closefractional: action.payload.closefractional
                        }
                },
                SetMovementSummary: (state, action) => {
                        const summary = action.payload.summary;
                        let delivery = 0;
                        let fromprod = 0;
                        let intertankin = 0;
                        let toprod = 0;
                        let sale = 0;
                        let intertankout = 0;
                        // console.log(action.payload.summary);
                        if (summary) {
                                for (let s of summary) {
                                        switch (s.movement_type_name.toString().toLowerCase()) {
                                                case 'delivery':
                                                        delivery = s.final_weight; break;
                                                case 'from prod':
                                                        fromprod = s.final_weight; break;
                                                case 'to prod':
                                                        toprod = s.final_weight; break;
                                                case 'inter-tank (in)':
                                                        intertankin = s.final_weight; break;
                                                case 'inter-tank (out)':
                                                        intertankout = s.final_weight; break;
                                                case 'sale':
                                                        sale = s.final_weight;  break;
                                                default: break;
                                        } 
                                }
                        }

                        state.movementSummary = {
                                 delivery: delivery,
                                 fromprod: fromprod,
                                 toprod: toprod,
                                 intertankin: intertankin,
                                 intertankout: intertankout,
                                 sale: sale
                        }
                },
                StartSaving: (state, action) => {
                        state.saveStatus = {
                                isSaving: true,
                                success: false,
                                alreadyexists: false,
                                error: ''
                        }
                },
                SetSaving: (state, action) => {
                        state.saveStatus = {
                                isSaving: false,
                                success: action.payload.success,
                                alreadyexists: action.payload.alreadyexists,
                                error: action.payload.error
                        }
                },
                ResetSaveStatus: (state, action) => {
                        state.saveStatus = {
                                isSaving: false,
                                success: false,
                                alreadyexists: false,
                                error: ''
                        }
                },
                StartGetDayEntryDetails: (state, action) => {
                        state.dayEntry = {
                                details: null,
                                isLoading: true
                        }
                },
                SetDayEntryDetails: (state, action) => {
                        state.dayEntry ={
                                details: action.payload.details,
                                isLoading: false
                        }
                },
                StartCancelling: (state, action) => {
                        state.cancelStatus = {
                                isCancelling: true,
                                success: false,
                                error: ''
                        }
                },
                SetCancelStatus: (state, action) => {
                        state.cancelStatus = {
                                isCancelling: false,
                                success: action.payload.success,
                                error: action.payload.error
                        }
                },
                ResetCancelStatus: (state, action) => {
                        state.cancelStatus = {
                                isCancelling: false,
                                success: false,
                                error: ''
                        }
                },
 
        }
});